import { render, staticRenderFns } from "./SingleProjectTask.vue?vue&type=template&id=581cb798&scoped=true&"
import script from "./SingleProjectTask.vue?vue&type=script&lang=js&"
export * from "./SingleProjectTask.vue?vue&type=script&lang=js&"
import style0 from "./SingleProjectTask.vue?vue&type=style&index=0&id=581cb798&prod&scoped=true&lang=css&"
import style1 from "./SingleProjectTask.vue?vue&type=style&index=1&id=581cb798&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581cb798",
  null
  
)

export default component.exports